import { RECORDS_APPROVE } from 'scenes/Permissions/constants/permissions';
import { getNearestUserProjectPermissions } from 'scenes/Permissions/store/selectors/personalPermissionsSelectors';

export const checkPermissionsToApproveRecord = (
  record,
  userProjectPermissions,
  projects,
  resourceDefaultPermissions,
  isAdminOfSelectedRecordProject
) => {
  const nearestUserProjectPermissionsForRecord =
    getNearestUserProjectPermissions(
      projects,
      userProjectPermissions,
      record.project
    );

  const defaultPermissionsWithNearestProjectPermissions = {
    ...resourceDefaultPermissions,
    ...nearestUserProjectPermissionsForRecord,
  };

  const isPermissionToApprove =
    defaultPermissionsWithNearestProjectPermissions[RECORDS_APPROVE];

  return isAdminOfSelectedRecordProject || isPermissionToApprove;
};
